import React, {PropsWithChildren} from 'react';

const BoxContent: React.FC<PropsWithChildren & {noBackground?: boolean}> = ({
  children,
  noBackground = false
}) => {
  return (
    <div className="page">
      <div className={`boxContent ${noBackground ? 'noBG' : ''}`}>
        {children}
      </div>
    </div>
  );
};

export default BoxContent;
